import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';

export class SwitchAdapter extends TestAdapter {
  /**
   * Clear and commit the value of the Switch
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }

  /**
   * Change the value of the component if it is different than it was.
   * @param value {boolean | undefined} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: boolean | undefined) {
    const driver = this.getTestDriver();
    const el = await this.getElement();

    const roleSwitchElem = await el.waitForElement(byCss(`div[role="switch"]`));
    const isChecked = (await roleSwitchElem.getAttribute('aria-checked')) === 'true';
    // if the value is undefined make it false.
    const newVal = value ?? false;
    if (isChecked !== newVal) {
      await driver.click(roleSwitchElem);
    }
  }
}
